/** @jsx isolateComponent */
import React from 'react';
import {
  isolateComponent,
  labelStyles,
  withModifier,
} from '@zapier/common-utils';

type ListProps<T> = {
  /** Optional id to assign to ul element */
  id?: string;
  /** List Item renderer */
  itemRenderer: (item: T, index: number) => React.ReactNode;
  /** Loaded items */
  items: Array<T>;
  /** Gap Spacing for list items */
  gap?: number;
  /** Function that takes (item, index) and returns the row key */
  getKey: (item: T, index: number) => string | number;
};

const getKeyDefault = <T extends any>(_item: T, i: number): number => i;

const defaultProps = {
  getKey: getKeyDefault,
};

const Styles = labelStyles(__filename, {
  root<T>(props: ListProps<T>) {
    return [
      {
        listStyleType: 'none',
        margin: 0,
        marginBlockEnd: 0,
        marginBlockStart: 0,
        padding: 0,
        paddingInlineStart: 0,
        WebkitMarginAfter: 0,
        WebkitMarginBefore: 0,
        WebkitPaddingStart: 0,
      },
      props.gap &&
        withModifier('gap', {
          display: 'grid',
          gridGap: props.gap,
        }),
    ];
  },
});

/**
 * Shows a list of items
 */
function List<T>(props: ListProps<T>) {
  const listItems = props.items.map((item, i) => (
    <li key={props.getKey(item, i)}>{props.itemRenderer(item, i)}</li>
  ));

  return (
    <ul css={Styles.root(props)} id={props.id}>
      {listItems}
    </ul>
  );
}

List.defaultProps = defaultProps;

export default List;
